import { EMAIL_TYPE_SCOPES, getHasAccessToEmailType } from '../helpers/EmailTypeHelpers';
export const emailTypesAuthedFor = scopes => {
  return Object.keys(EMAIL_TYPE_SCOPES).filter(emailType => getHasAccessToEmailType(scopes, emailType));
};
export const canCreateDragDropEmail = scopes => {
  const hasEmailEditorAccess = scopes.indexOf('email-editor-access') >= 0;
  if (!hasEmailEditorAccess) {
    return false;
  }
  const hasScopesForAnyEmailType = emailTypesAuthedFor(scopes).length > 0;
  return hasScopesForAnyEmailType;
};
export const hasAccessToAnEmailType = scopes => emailTypesAuthedFor(scopes).length > 0;